import React from "react";
import { Mail, Instagram, MapPin, MessageCircle, Sparkles } from "lucide-react";

export const Contact = () => {
    return (
        <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-brand-ink text-brand-cream relative overflow-hidden">
            {/* glow ornaments */}
            <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-brand-coral/30 blur-3xl" />
            <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-brand-gold/20 blur-3xl" />

            <div className="max-w-6xl mx-auto px-6 sm:px-8 relative grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
                <div>
                    <p className="text-xs tracking-[0.25em] uppercase text-brand-gold mb-4">Get in touch</p>
                    <h2 className="font-display text-5xl sm:text-7xl leading-[1.02] text-balance">
                        Let's design a moment they'll
                        <br /><em className="text-brand-coralLight">never forget</em>.
                    </h2>
                    <p className="mt-6 text-white/70 max-w-md leading-relaxed">
                        Prefer email, text, or DM? I'm easy to reach. Most inquiries get a custom quote
                        the same day.
                    </p>
                </div>

                <div className="space-y-4">
                    {[
                        { icon: Mail, label: "Email", value: "GlowMomentzz@gmail.com", href: "mailto:GlowMomentzz@gmail.com", testid: "contact-email" },
                        { icon: MessageCircle, label: "Text or call", value: "(925) 276-0661", href: "tel:+19252760661", testid: "contact-phone" },
                        { icon: Instagram, label: "Instagram", value: "@glowmomentz", href: "https://instagram.com/glowmomentz", testid: "contact-instagram" },
                        { icon: MapPin, label: "Based in", value: "Pittsburg, CA · Bay Area & beyond", href: null, testid: "contact-location" },
                    ].map((c) => {
                        const Icon = c.icon;
                        const Inner = (
                            <>
                                <span className="h-12 w-12 rounded-2xl bg-white/10 flex items-center justify-center group-hover:bg-brand-coral/30 transition-colors">
                                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                                </span>
                                <div>
                                    <div className="text-[11px] tracking-[0.25em] uppercase text-white/50">{c.label}</div>
                                    <div className="text-lg font-display">{c.value}</div>
                                </div>
                            </>
                        );
                        return c.href ? (
                            <a
                                key={c.label}
                                href={c.href}
                                target={c.href.startsWith("http") ? "_blank" : undefined}
                                rel="noopener noreferrer"
                                className="group flex items-center gap-5 rounded-2xl border border-white/10 hover:border-white/30 px-5 py-4 transition-all hover:translate-x-1"
                                data-testid={c.testid}
                            >
                                {Inner}
                            </a>
                        ) : (
                            <div key={c.label} className="flex items-center gap-5 rounded-2xl border border-white/10 px-5 py-4" data-testid={c.testid}>
                                {Inner}
                            </div>
                        );
                    })}

                    <a
                        href="#inquiry"
                        data-testid="contact-cta-inquiry"
                        className="mt-2 inline-flex items-center gap-2 rounded-full bg-brand-cream text-brand-ink px-7 py-3.5 text-sm hover:bg-brand-coralLight hover:text-white transition-all"
                    >
                        <Sparkles className="h-4 w-4 text-brand-gold" />
                        Or use the inquiry form
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Contact;
